module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"SearchInput":{"ariaLabel":"Vyhledávání","button":"Hledat","placeholder":"Co chcete najít?"}},"de":{"SearchInput":{"placeholder":"Was suchen Sie?","ariaLabel":"Suche","button":"Suchen"}},"sk":{"SearchInput":{"placeholder":"Čo hľadáte?","ariaLabel":"Vyhľadávanie","button":"Hľadať"}}}')
  delete Component.options._Ctor
}
